import React from "react";

interface IndicatorProps {
	children?: any;
	style?: any;
	className?: string;
}

const Indicator = ({ children, style, className }: IndicatorProps) => {
	let _className =
		"text-[12px] p-2 w-[20px] h-[20px] flex items-center justify-center font-bold " +
		className;
	if (!className?.includes("rounded-")) {
		_className += " rounded-full";
	}

	if (!className?.includes("bg-")) {
		_className += " bg-red text-white";
	}

	return (
		<span {...{ style }} className={_className}>
			{children}
		</span>
	);
};

export default Indicator;
